import React, { useState, FormEvent, FC, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "../../store/actions/auth";
import { auth } from "firebaseui";
import { User } from "../../models/user";
import { firestore, Auth } from "../../firebase";
import { uiConfig } from "./auth";

interface LProps {
  login: (cred: LoginCred) => any;
}

const Login: FC<LProps> = ({ login }) => {
  document.getElementsByTagName("title")[0].innerHTML = "login";
  const [userData, setUserdata] = useState({
    email: "",
    password: "",
  });
  const [feedback, setFeedback] = useState("");
  let mounted = true;

  const onChange = (e: FormEvent<HTMLInputElement>) => {
    setUserdata({
      ...userData,
      [e.currentTarget.id]: e.currentTarget.value,
    });
  };

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const { email, password } = userData;
    if (!email || !password) {
      setFeedback("Both fields are required");
    } else if (password.length < 6) {
      setFeedback("Password must be 6 or more characters");
    } else {
      let res = await login(userData);

      if (!res) mounted = false;

      if (mounted) {
        setFeedback(res);
      }
    }
    if (mounted) {
      setTimeout(() => setFeedback(""), 6000);
    }
  };

  useEffect(() => {
    if (auth.AuthUI.getInstance()) {
      const ui = auth.AuthUI.getInstance()!;
      ui.start("#auth", uiConfig);
    } else {
      const ui = new auth.AuthUI(Auth());
      ui.start("#auth", uiConfig);
    }

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      mounted = false;
    };
  });

  return (
    <div
      className="uk-width-2-5@l uk-width-2-5@m uk-margin-auto uk-margin-large-top uk-width-1-1@s"
    >
      <form
        onSubmit={onSubmit}
        className="uk-card form bg-dark uk-card-body uk-border-rounded uk-margin-auto"
      >
        <h3 className="">Log in</h3>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Email</label>
          <input
            type="email"
            id="email"
            onChange={onChange}
            className="uk-input"
            placeholder="Email"
          />
        </div>

        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Password</label>
          <input
            type="password"
            id="password"
            onChange={onChange}
            className="uk-input"
            placeholder="Password"
          />
        </div>
        {feedback && (
          <div
            style={{
              background: "red",
              padding: "8px",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {feedback}
          </div>
        )}
        <div className="uk-margin-small-top uk-flex-center">
          <button
            className="uk-button  uk-border-rounded"
            style={{ color: "#000" }}
          >
            Login
          </button>
        </div>

        <div id="auth"></div>
        <div
          className="uk-margin-small-top black-text"
          style={{ color: "#000" }}
        >
          Don't have an account? <Link to="/register">Sign up</Link>
        </div>
      </form>
    </div>
  );
};

export default connect(null, { login })(Login);
